import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import customerMapData from "../data/installation-data";

// Fix default marker icons broken by webpack 5 asset handling
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Fits the map to the bounds of all markers on first render
const FitBounds = ({ data }) => {
  const map = useMap();
  React.useEffect(() => {
    if (!data.length) return;
    const bounds = L.latLngBounds(data.map((c) => [c.lat, c.lng]));
    map.fitBounds(bounds, { padding: [48, 48] });
  }, [map, data]);
  return null;
};

const CustomerMap = () => {
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  return (
    <div className="page-container customer-map-page">
      <h1 className="main-heading">Our Customers</h1>
      <p className="paragraph">
        Click on a marker to view customer details.
      </p>

      <div className="customer-map-layout">
        <div className="customer-map-container">
          <MapContainer
            center={[11.5, 78.5]}
            zoom={7}
            scrollWheelZoom={true}
            style={{ height: "100%", width: "100%" }}
          >
            <FitBounds data={customerMapData} />
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {customerMapData.map((customer) => (
              <Marker
                key={customer.id}
                position={[customer.lat, customer.lng]}
                eventHandlers={{
                  click: () => setSelectedCustomer(customer),
                }}
              >
                <Popup>
                  <div className="customer-map-popup">
                    <strong className="popup-name">{customer.name}</strong>
                    <span className="popup-city">{customer.city}</span>
                    <span className="popup-state">{customer.state}</span>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

        <section className="customer-map-sidebar">
          <h2 className="customer-map-sidebar-title">Customers</h2>
          <div className="customer-chip-grid">
            {customerMapData.map((customer) => (
              <button
                key={customer.id}
                className={`customer-chip${selectedCustomer?.id === customer.id ? " active" : ""}`}
                onClick={() => setSelectedCustomer(selectedCustomer?.id === customer.id ? null : customer)}
                title={`${customer.name} — ${customer.city}`}
              >
                <span className="chip-name">{customer.name}</span>
                <span className="chip-city">{customer.city}</span>
              </button>
            ))}
          </div>

          {/* {selectedCustomer && (
            <div className="customer-map-detail-card">
              <h3 className="detail-card-name">{selectedCustomer.name}</h3>
              <p className="detail-card-row">
                <span className="detail-label">City</span>
                <span className="detail-value">{selectedCustomer.city}</span>
              </p>
              <p className="detail-card-row">
                <span className="detail-label">State</span>
                <span className="detail-value">{selectedCustomer.state}</span>
              </p>
            </div>
          )} */}
        </section>
      </div>
    </div>
  );
};

export default CustomerMap;
